<template>
    <div>
        <span class="text-secondary font-italic">Returns must be like new condition and in orignal packaging</span>
    </div>
    <div class="row vl-parent">
        <LoadingOverlay v-model:active="loading" :is-full-page="false" />
        <div class="col-xl">
            <div class="card border mt-3">
                <div class="bg-primary card-header p-2">
                    <h6 class="text-light m-0"><i class="mr-2 fas fa-cart-plus text-light" aria-hidden="true"></i>
                        Add
                        Product</h6>
                </div>
                <div class="card-body p-0">
                    <div class="p-3">
                        <div class="text-center mb-3">
                            <SelectButton v-model="returnType" class="ReturnWarrantySelectButton"
                                :options="['Return', 'Warranty']" @change="typeChanged" />
                        </div>
                        <div class="row">
                            <div>
                                <i class="fa-solid fa-square-xmark nav-icon m-2"
                                    :class="selectedProduct ? 'text-danger' : 'text-secondary'"
                                    :style="selectedProduct ? 'cursor: pointer;' : ''" @click="clearSearch"></i>
                            </div>
                            <span class="p-float-label mr-2" style="flex: 1;">
                                <AutoComplete id="productAutoComplete" v-model="selectedProduct"
                                    :suggestions="availableItems" @complete="autoCompleteFinish" optionLabel="sku_with_name"
                                    :minLength="2" :delay="300" dropdown dropdownMode="current" class="w-100">
                                    <template #option="slotProps">
                                        <div style="vertical-align: middle;">
                                            <img :alt="slotProps.option.sku" :src="slotProps.option.thumb_url" class="mr-2"
                                                style="max-width: 50px; max-height: 50px;" />
                                            <span>{{ slotProps.option.sku_with_name }}</span>
                                        </div>
                                    </template>
                                </AutoComplete>
                                <label for="productAutoComplete">
                                    {{ selectedProduct ? 'Selected Product' : 'Search Returnable Products' }}
                                </label>
                            </span>
                        </div>
                        <div v-if="selectedProduct?.sku">
                            <div class="mt-3 ml-3 mr-3 row">
                                <div class="mr-3 " v-if="selectedProduct.thumb_url">
                                    <img :src="selectedProduct.thumb_url" alt="Product Image"
                                        style="max-width: 50px; max-height: 50px;" />
                                </div>
                                <div class="col">
                                    <div class="mb-0"><span class="font-weight-bold">{{ selectedProduct.sku
                                    }}</span>
                                    </div>
                                    <div>{{ selectedProduct.name }}</div>
                                </div>
                            </div>
                            <div v-if="selectedProduct?.is_manufacturer_direct_warranty == 1">
                                <div class="mt-3">
                                    Warranties are handled directly with this manufacturer. Please use the link below
                                    to submit a request with the manufacturer.
                                </div>
                            </div>
                            <div v-if="selectedProduct.warranty_link" class="mt-2 text-center">
                                <strong>
                                    <a :href="selectedProduct.warranty_link" target="_blank">
                                        Warranty Information
                                    </a>
                                </strong>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedProduct?.sku && returnableShipmentItems" class="border-top">
                        <div class="pl-3 pr-3 pb-3">
                            <div class="mt-3 card border" v-for="shipmentItem in returnableShipmentItems">
                                <div class="card-header p-2">
                                    <a :href="route('mtd.order.view', shipmentItem.order_item?.order_id)"
                                        target="_blank">Order#:
                                        {{ shipmentItem.order_item?.order_id }}</a>
                                    <span class="float-right">
                                        Shipped: {{ moment(shipmentItem.shipped_at).format('M/D/YY') }}
                                    </span>
                                </div>
                                <div class="card-body p-2">
                                    <div class="row">
                                        <div class="col" style="vertical-align: middle;">
                                            <div class="mr-3">
                                                <span>
                                                    Price: {{ formatDollars(shipmentItem.order_item.cost_item)
                                                    }}
                                                </span>
                                            </div>
                                            <div class="mr-3">
                                                {{ shipmentItem.returnable_quantity }} Eligible for {{
                                                    returnType
                                                }}
                                            </div>
                                        </div>
                                        <JetButton v-if="selectedProduct?.is_manufacturer_direct_warranty == 1"
                                            class="m-2 mr-3 float-right"
                                            :goesTo="route('order.receipt', { order: shipmentItem.order_item?.order_id, print: 1 })"
                                            icon="fa fa-print">
                                            Proof of Purchase
                                        </JetButton>
                                        <JetButton v-else class="m-2 mr-3 float-right"
                                            @click="selectShipmentItem(shipmentItem)">
                                            Add To Return Cart
                                        </JetButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl mt-3">
            <card icon="fas fa-shopping-cart" headerStyle="primary" title="Return Cart" class="mb-3"
                bodyClasses="pl-3 pr-3 pb-3">
                <table class="w-100" style="border-collapse: collapse;">
                    <tr>
                        <td colspan="4">
                            <div class="card-header p-2 text-center border"
                                style="margin-left: -1px; margin-right: -2px;  margin-bottom: -1px;">
                                <span class="m-0 font-weight-bold">Warranty</span>
                            </div>
                        </td>
                    </tr>
                    <template v-if="cartWarrantyItems.length">
                        <template v-for="returnItem in cartWarrantyItems">
                            <ReturnItem :returnItem="returnItem" showDelete=true @returnItemDelete="deleteCartItem" />
                        </template>
                        <tr class="border">
                            <td class="pt-3 pl-3 pb-3 text-right " colspan="3"><span class="font-weight-bold">Total</span>
                            </td>
                            <td class="p-3 text-center "><span class="font-weight-bold">{{
                                cartWarrantyItems.reduce((total, warrantyCartItem) => {
                                    return total + warrantyCartItem.quantity
                                }, 0) }}</span>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="border-left border-right border-bottom">
                            <td colspan="4" class="p-3">
                                <span>No Warranty Items in Cart</span>
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="4">
                            <div class="pb-3"></div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            <div class="card-header p-2 text-center border"
                                style="margin-left: -1px; margin-right: -2px; margin-bottom: -1px;">
                                <span class="m-0 font-weight-bold">Return</span>
                            </div>
                        </td>
                    </tr>
                    <template v-if="cartReturnItems.length">
                        <template v-for="returnItem in cartReturnItems">
                            <ReturnItem :returnItem="returnItem" showDelete=true @returnItemDelete="deleteCartItem" />
                        </template>
                        <tr class="border">
                            <td class="pl-3 pb-3 pt-3 text-right" colspan="3"><span class="font-weight-bold">Total</span>
                            </td>
                            <td class="p-3 text-right "><span class="font-weight-bold">{{
                                formatDollars(returnCartTotal) }}</span>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="border-left border-right border-bottom">
                            <td colspan="4" class="p-3">
                                <span>No Return Items in Cart</span>
                            </td>
                        </tr>
                    </template>
                </table>
                <div class="mt-3 text-center" v-if="returnCartItems.length && !isAdminView">
                    <JetButton :goesTo="route('mtd.return.checkout')">Complete Return <i
                            class="ml-2 fa-solid fa-boxes-packing nav-icon"></i></JetButton>
                </div>
            </card>
        </div>
    </div>
    <teleport to="body">
        <AddReturnItemModal :shipmentItem="selectedShipmentItem" :isWarranty="isWarranty"
            @itemAddedToReturnCart="refreshCart" @show="getShowAddReturnIitemInterface" />
    </teleport>
</template>

<script>
import ReturnItem from './ReturnItem.vue'
import JetLabel from '@/Jetstream/Label'
import JetButton from '@/Jetstream/Button'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import AutoComplete from 'primevue/autocomplete'
import moment from 'moment'
import SelectButton from 'primevue/selectbutton'
import AddReturnItemModal from '@/Components/Modals/AddReturnItemModal'
import LoadingOverlay from '@/Components/General/LoadingOverlay.vue';

export default {
    components: {
        JetLabel,
        JetButton,
        ReturnItem,
        LoadingOverlay,
        JetDialogModal,
        JetDangerButton,
        AutoComplete,
        SelectButton,
        AddReturnItemModal,
    },
    props: {
        mtdId: Number,
        isAdminView: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            returnCartItems: [],
            returnCartTotal: 0.0,
            selectedProduct: null,
            returnType: 'Return',
            availableItems: [],
            returnableShipmentItems: [],
            selectedShipmentItem: null,
        }
    },
    created() {
        this.moment = moment;
    },
    mounted() {
        this.$emit("refreshCart", {
            refreshCart: () => this.refreshCart()
        });
        this.refreshCart()
    },
    watch: {
        selectedProduct() {
            if (this.selectedProduct?.id) {
                this.loading = true
                axios.post(this.route(this.routePrefix + '.return.getReturnableShipmentItems', this.selectedProduct.id),
                    { mtdId: this.mtdId, isWarranty: this.isWarranty })
                    .then((response) => {
                        if (response.data.success) {
                            this.returnableShipmentItems = response.data.results;
                        }
                        this.loading = false
                    });
            }
        }
    },
    computed: {
        routePrefix() {
            return this.isAdminView ? 'admin' : 'mtd'
        },
        isWarranty() {
            return this.returnType == 'Warranty'
        },
        cartReturnItems() {
            return this.returnCartItems.filter(function (cartItem) {
                return !cartItem.is_warranty;
            })
        },
        cartWarrantyItems() {
            return this.returnCartItems.filter(function (cartItem) {
                return cartItem.is_warranty;
            })
        }
    },
    methods: {
        deleteCartItem(cartItemId) {

            this.$confirm.require({
                message: "Are you sure you want to remove this items from your Returns Cart?",
                header: "Remove item from Returns Cart",
                icon: 'text-danger pi pi-exclamation-triangle',
                acceptLabel: "Yes",
                rejectLabel: "Cancel",
                accept: () => {
                    this.loading = true
                    axios.delete(this.route('mtd.return.deleteReturnItem', cartItemId),
                        { mtdId: this.mtdId }).then((response) => {
                            if (response.status == 200) {
                                this.returnCartItems = response.data.returnCartItems;
                                this.returnCartTotal = response.data.returnCartTotal;
                            }
                            this.loading = false;
                        });
                }
            })
        },
        refreshCart() {
            this.loading = true
            this.clearSearch()
            axios.post(this.route(this.routePrefix + '.return.cartRefresh'), { mtdId: this.mtdId }).then((response) => {
                if (response.status == 200) {
                    this.returnCartItems = response.data.returnCartItems;
                    this.returnCartTotal = response.data.returnCartTotal;
                }
                this.loading = false
            });
        },
        typeChanged() {
            this.clearSearch();
            this.search(null);
        },
        autoCompleteFinish(e) {
            this.search(e.query)
        },
        search(searchText) {
            axios.post(this.route(this.routePrefix + '.return.searchReturnableProducts'),
                { mtdId: this.mtdId, searchText: searchText, isWarranty: this.isWarranty })
                .then((response) => {
                    if (response.data.success) {
                        this.availableItems = response.data.results;
                    }
                });
        },
        clearSearch() {
            this.selectedProduct = null;
            this.availableItems = null;
            this.returnableShipmentItems = null;
        },
        selectShipmentItem(shipmentItem) {
            this.selectedShipmentItem = shipmentItem;
            this.$options.showAddReturnItemInterface.show()
        },
        // Setting the interface when emitted from child
        getShowAddReturnIitemInterface(childInterface) {
            this.$options.showAddReturnItemInterface = childInterface;
        },
    },
    showAddReturnItemInterface: {
        show: () => { },
    },
}
</script>

<style>
.ReturnWarrantySelectButton>.p-button {
    width: 85px;
}
</style>